import React, { useState } from 'react';
import { Box, Typography, Paper, Container } from '@mui/material';
import PercentIcon from '@mui/icons-material/Percent';
import Dialog from '@mui/material/Dialog';
import TaxList from './TaxList';
import TaxForm from './TaxForm';

const TaxSettings = () => {
  const [selectedTax, setSelectedTax] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [taxDialogOpen, setTaxDialogOpen] = useState(false);

  const handleTaxEdit = (tax) => {
    setSelectedTax(tax);
    setTaxDialogOpen(true);
  };

  const handleTaxSuccess = () => {
    setSelectedTax(null);
    setTaxDialogOpen(false);
    setRefresh(!refresh);
  };

  const handleAddTax = () => {
    setSelectedTax(null);
    setTaxDialogOpen(true);
  };

  return (
    <Container className="settings-page" maxWidth="xl" sx={{ mt: 2, mb: 2, px: 2 }}>
      <Box className="settings-heading" sx={{ mb: 2 }}>
        <Typography 
          variant="h6" 
          sx={{ 
            fontWeight: 600,
            color: 'text.primary',
            mb: 0.5,
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            fontSize: '1rem'
          }}
        >
          <PercentIcon sx={{ fontSize: 24, color: '#43a047' }} />
          Tax Management
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
          Manage tax rates and configurations
        </Typography>
      </Box>

      <Paper className="settings-shell" sx={{ 
        border: '1px solid',
        borderColor: 'divider',
        boxShadow: 1
      }}>
        <Box className="settings-content" sx={{ p: 2 }}>
          <TaxList 
            onEdit={handleTaxEdit} 
            onAdd={handleAddTax}
            key={refresh} 
          />
        </Box>
      </Paper>

      {/* Tax Dialog */}
      <Dialog 
        open={taxDialogOpen} 
        onClose={() => {
          setTaxDialogOpen(false);
          setSelectedTax(null);
        }}
        maxWidth="sm"
        fullWidth
      >
        <TaxForm 
          selected={selectedTax} 
          onSuccess={handleTaxSuccess} 
          onCancel={() => {
            setTaxDialogOpen(false);
            setSelectedTax(null);
          }} 
        />
      </Dialog>
    </Container>
  );
};

export default TaxSettings;
